import { injectable } from 'inversify';

@injectable()
export class OfflineDetectionService {
  private _isOnline = true;

  public constructor() {
    this._isOnline = navigator.onLine;

    window.addEventListener('online', this._handleOnlineStatusChange.bind(this));
    window.addEventListener('offline', this._handleOnlineStatusChange.bind(this));
  }

  public getOnlineStatus(): boolean {
    return this._isOnline;
  }

  private _handleOnlineStatusChange(): void {
    this._isOnline = navigator.onLine;
  }
}
